import { AvatarService } from '../../../avatar.service';
import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ChangeAvatarComponent } from 'app/account/change-avatar/change-avatar.component';
import { UpdateProfileComponent } from 'app/account/update-profile/update-profile.component';
import { RegisterSignatureComponent } from 'app/e-signature/register-signature/register-signature.component';
import { IdexService } from 'app/idex.service';
import { Toast } from 'app/shared/toast/toast';
import { TranslateService } from '@ngx-translate/core';

declare let $: any;

@Component({
  selector: 'app-general',
  templateUrl: './general.component.html',
  styleUrls: ['./general.component.css']
})
export class GeneralComponent implements OnInit {

  user: any;
  email: string
  name: string
  avatarUrl: string;
  avatar2Url: string;
  avatarLoaded: boolean;
  avatar2Loaded: boolean;
  includeName: any
  includeDate: any
  hasSignature: any
  signatureId: string;
  initialId: string;

  imageSignaturePreview: any;
  currentDate: Date;

  private registerSignDialog: MatDialogRef<RegisterSignatureComponent>;
  private updateProfile: MatDialogRef<UpdateProfileComponent>;
  @ViewChild('canvasOriginal', { static: true }) public canvasOriginal: ElementRef;
  @ViewChild('canvasPatternTmp', { static: true }) public canvasPatternTmp: ElementRef;
  imageInitializePreview: string;
  fNameValue: string;
  lNameValue: string;
  hasInitial: any;

  editEmail:boolean

  constructor( private dialog: MatDialog , public service: IdexService , private toast: Toast, private translate: TranslateService ,private avatarService:AvatarService) { }

  ngOnInit(): void {
    this.user = this.service.user;
    const splitName = this.service.user.name.trim().split(' ', 3); 
    this.fNameValue = splitName[0];
    if(splitName[1] != null){
       this.lNameValue = splitName[1];
    }

    this.service.getProfile()
    .subscribe((data: any) => {
      this.currentDate = new Date();
      this.includeName = data.includeName;
      this.includeDate = data.includeDate;
      this.hasSignature = data.hasSignature;
      this.hasInitial = data.hasInitial;
      this.signatureId = data.signatureId;
      this.initialId = data.initialId;

      if (data.hasSignature) {
        const url = this.service.url + '/signature?version=' + Date.now() + '&lastmod=' + Date.now() + '&isChkName=' + this.includeName + '&isChkDate=' + this.includeDate + '&init=false';
        this.service.toDataURL(url, (dataUrl) => {
           document.getElementById('pSignatureShow').setAttribute('src', dataUrl);
           this.initialSignature();
        });
     } else {
        document.getElementById('pSignatureShow').setAttribute('src', 'assets/images/no_signature.png');
     }

     if (data.hasInitial) {
      const url = this.service.url + '/signature?version=' + Date.now() + '&lastmod=' + Date.now() + '&isChkName=false&isChkDate=false&init=true';
      this.service.toDataURL(url, function(dataUrl) {
         document.getElementById('pInitialShow').setAttribute('src', dataUrl);
      });
   } else {
      document.getElementById('pInitialShow').setAttribute('src', 'assets/images/no_initials.png');
   }

    })

    if(this.user){
      this.email = this.user.email
      this.name = this.user.name
    }

    this.avatarService.avatarUrl$.subscribe(url => {
      this.avatarUrl = url;
    });

    this.avatarService.avatar2Url$.subscribe(url => {
      this.avatar2Url = url;
    });

  }

  openChangeAvatar(e: Event) {
    e.stopPropagation();
    this.dialog.open(ChangeAvatarComponent, {
       disableClose: true,
       data: this
    });
 }

 updateAvatar(data: any): void {
  this.avatarLoaded = false;
  this.avatar2Loaded = false;
  setTimeout(() => {
     if (!this.user.avatar) {
        this.user = data;
        this.service.setUser(data);
     }
     const time = new Date().getTime();

     this.avatarService.updateAvatarUrl(this.service.url + this.user.avatar + '&' + time);
     this.avatarService.updateAvatar2Url(this.service.url + this.user.avatar2 + '&' + time);
  }, 200);
}

initialSignature(){
  let img = document.getElementById('pSignatureShow');
  let imgTmp = new Image();
  imgTmp.onload = () => {
     let canvas = this.canvasOriginal.nativeElement;
     let context = canvas.getContext("2d");
     var hRatio = canvas.width / imgTmp.width;
     var vRatio = canvas.height / imgTmp.height;
     var ratio = Math.min(hRatio, vRatio);
     var centerShiftX = ( canvas.width - imgTmp.width*ratio ) / 2;
     var centerShiftY = ( canvas.height - imgTmp.height*ratio ) / 2;  
     context.clearRect(0, 0, canvas.width, canvas.height);
     context.drawImage(imgTmp,0,0, imgTmp.width, imgTmp.height, centerShiftX, centerShiftY,
        (imgTmp.width) * ratio, imgTmp.height * ratio);
     const tmp = this.editPatternCanvas(this.canvasOriginal.nativeElement, 'original');
     
     document.getElementById('pSignatureShow').setAttribute('src', tmp.toDataURL());
     this.imageSignaturePreview = tmp.toDataURL();
  }
  imgTmp.src =img.getAttribute('src');
}

editPatternCanvas(oldCanvas: HTMLCanvasElement , type: string) {
  let canvasTmp = this.canvasPatternTmp.nativeElement;
  const ctx = canvasTmp.getContext('2d');
  ctx.clearRect(0, 0, canvasTmp.width, canvasTmp.height);

  if ((this.includeName || this.includeDate) && type !== 'init') {
     canvasTmp.width = oldCanvas.width + 75;
     canvasTmp.height = oldCanvas.height;

     ctx.drawImage(oldCanvas, -10, 0);

     const datepipe: DatePipe = new DatePipe('en-US');
     const formatDate = datepipe.transform(this.currentDate, 'dd/MM/yyyy');
     const formatTime = datepipe.transform(this.currentDate,  'HH:mm:ss Z');

     ctx.font = '200 8px Arial';
     const width = ctx.measureText(formatDate + ' ' + formatTime).width - 10;

     const x = canvasTmp.width - width;
     let y = canvasTmp.height / 2;
     if (this.includeName && this.includeDate) {
        y -= 10;
     }

     const lineSpace = 8;

     this.fillIncludeText(ctx, x, y, lineSpace, formatDate, formatTime);
  } else {
     canvasTmp.width = oldCanvas.width;
     canvasTmp.height = oldCanvas.height;
     ctx.drawImage(oldCanvas, 0, 0);
  }
  return canvasTmp;
}

fillIncludeText(ctx: any, x: number, y: number, lineSpace: number, date: string, time: string) {
  const user = JSON.parse(localStorage.getItem('idex-user'));
  if (this.includeName) {
     ctx.fillText('Digital signed by', x, y);
     y = y + lineSpace;
     let limit = 19;
     if (user.name.length <= limit) {
        ctx.fillText(user.name, x, y);
        y = y + lineSpace;
     } else {
        let len = user.name.length;
        let startIndex = 0;
        let endIndex = len - 1;
        while(startIndex <= endIndex){
           let str = user.name.substring(startIndex,startIndex + limit);
           startIndex += limit;
           ctx.fillText(str, x, y);
           y = y + lineSpace;
        }
     }
  }
  if (this.includeDate) {
     ctx.fillText('Date: ' + date, x, y);
     y = y +  lineSpace;
     ctx.fillText(time, x, y);
  }
}

openUpdateSignature(type) {
  this.registerSignDialog = this.dialog.open(RegisterSignatureComponent, {
     disableClose: true,
     data: this,
     autoFocus: false
  });
   if(type === 'Signature'){
      this.registerSignDialog.componentInstance.selectPatternStyle = 'Singnature' ;
   } else if(type === 'Initials'){
      this.registerSignDialog.componentInstance.selectPatternStyle = 'InitializeSign' ;
   }
  this.imageSignaturePreview = document.getElementById('pSignatureShow').getAttribute('src');
  this.imageInitializePreview = document.getElementById('pInitialShow').getAttribute('src');
  this.registerSignDialog.componentInstance.signatureId = this.signatureId;
  this.registerSignDialog.componentInstance.initialId = this.initialId;
  this.registerSignDialog.componentInstance.imageSignatureOriginal = this.imageSignaturePreview;
  this.registerSignDialog.componentInstance.imageInitOriginal = this.imageInitializePreview;
  this.registerSignDialog.componentInstance.fullNameValue = this.fNameValue + ' ' + this.lNameValue;
  this.registerSignDialog.componentInstance.includeName = this.includeName;
  this.registerSignDialog.componentInstance.includeDate = this.includeDate;
  this.registerSignDialog.componentInstance.hasSignature = this.hasSignature;
  this.registerSignDialog.componentInstance.hasInitial = this.hasInitial;

  this.registerSignDialog.afterClosed().subscribe(result => {
     if (result) {
        this.service.getProfile()
           .subscribe((data: any) => {
              this.hasSignature = data.hasSignature;
              this.hasInitial = data.hasInitial;
           });
        this.includeName = this.registerSignDialog.componentInstance.includeName;
        this.includeDate = this.registerSignDialog.componentInstance.includeDate;
        this.service.toDataURL(this.service.url + '/signature?version=' + Date.now() + '&lastmod=' + Date.now() + '&isChkName=' + this.includeName + '&isChkDate=' + this.includeDate + '&init=false', (dataUrl) => {
           document.getElementById('pSignatureShow').setAttribute('src', dataUrl);
           this.imageSignaturePreview = dataUrl;
           this.initialSignature();
        });
        this.service.toDataURL(this.service.url + '/signature?version=' + Date.now() + '&lastmod=' + Date.now() + '&isChkName=false&isChkDate=false&init=true', function(dataUrl) {
           document.getElementById('pInitialShow').setAttribute('src', dataUrl);
        });
     }
  });
}


openUpdateProfile() {
  this.updateProfile = this.dialog.open(UpdateProfileComponent, {
      disableClose: true,
      data: this
   });
   this.updateProfile.componentInstance.updateName = true

   this.updateProfile.afterClosed().subscribe(result => {
      
      if(result){
         this.name =  this.service.user.name
         const splitName = this.service.user.name.trim().split(' ', 3); 
         this.fNameValue = splitName[0];
         if(splitName[1] != null){
            this.lNameValue = splitName[1];
         }

         this.updateUser();
      }
      
   })
}

beginRename(item: any) {
   this.editEmail = true;
   setTimeout(() => {
      const input = $('#edit-email').focus();
      let i;

      i = item.length;
      if (input.setSelectionRange) {
         input.setSelectionRange(0, i);
      } else if (input.createTextRange) {
         const range = input.createTextRange();
         range.collapse(true);
         range.moveEnd('character', i);
         range.moveStart('character', 0);
         range.select();
      } else if (input.selectionStart) {
         input.selectionStart = 0;
         input.selectionEnd = i;
      }
   }, 200);
}

rename(email){
   const value = $('#edit-email').val().trim();
   if (value.length === 0) {
      return;
   }else if(email.toLowerCase() === value.toLowerCase()){
      this.endChangeEmail()
   }else if( !this.checkPattern(value) ){
      this.translate.get('signup.error_email').subscribe((msg) => {
         this.toast.error(msg);
      });
   }else{
      this.service.updateEmail(value).subscribe(res => {
         this.service.user.email = value.toLowerCase();
         this.email = value.toLowerCase();
         this.updateUser();
         this.endChangeEmail()
      },err => {
         this.toast.error(err.message);
      });
      }
}

checkPattern(value:string) {
   const pattern = /^[_A-Za-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
   return pattern.test(value);
 }

renameKeyDown(event: KeyboardEvent, email: any) {
   if (event.key === 'Enter') {
      this.rename(email);
   } else if (event.key === 'Escape') {
      $('#edit-email').val(email);
      this.endChangeEmail();
   }
}

endChangeEmail() {
   this.editEmail = false
}

updateUser(){
   localStorage.setItem('idex-user',JSON.stringify(this.service.user))
}

}
